import {useEffect} from "react";
import CryptoJS from "crypto-js";

/**
 * solapi intro page
 * https://www.bizting.co.kr/hosting/solapi/intro
 * */
const HostingSIntro = () => {
    useEffect(() => {
        const state = {
            hostType: 'S',
        };

        let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

        let url = `${process.env.REACT_APP_SOLAPI_INTRO_REDIRECT_URI}`;
        url += `?state=${encryptedState}`;

        window.location.href = url;
    });
};

export default HostingSIntro;
